
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { LucideIcon } from 'lucide-react';
import { CheckCircle } from 'lucide-react';

interface CampaignType {
  id: string;
  title: string;
  icon: LucideIcon;
  description: string;
  setupSteps: string[];
}

interface CampaignTypeCardProps {
  campaign: CampaignType;
  onSelect: () => void;
}

const CampaignTypeCard: React.FC<CampaignTypeCardProps> = ({ campaign, onSelect }) => {
  return (
    <Card className="h-full flex flex-col hover:shadow-md transition-shadow">
      <CardHeader>
        <div className="flex items-center space-x-2">
          <div className="bg-primary/10 p-2 rounded-full">
            <campaign.icon className="h-6 w-6 text-primary" />
          </div>
          <CardTitle className="text-lg">{campaign.title}</CardTitle>
        </div>
        <CardDescription>{campaign.description}</CardDescription>
      </CardHeader>
      <CardContent className="flex-grow">
        <h4 className="font-medium text-sm mb-2">How to Set Up:</h4>
        <ul className="space-y-1">
          {campaign.setupSteps.map((step, index) => (
            <li key={index} className="flex items-start text-sm">
              <CheckCircle className="h-4 w-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
              <span className="text-gray-600">{step}</span>
            </li>
          ))}
        </ul>
      </CardContent>
      <CardFooter>
        <Button className="w-full" onClick={onSelect}>
          Set Up {campaign.title}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default CampaignTypeCard;
